import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Grid, CircularProgress, Button, Typography } from '@mui/material';
import { FiEyeOff, FiEye } from 'react-icons/fi';
import { useFormik } from 'formik';
import Page from '../components/Page';
import { useNavigate } from 'react-router-dom';
import { GoldMindsLogo } from 'src/images';
import { ResetPasswordBg1, ResetPasswordBg2, ResetPasswordBg3, ResetPasswordBg4 } from 'src/images';
import { IoClose } from 'react-icons/io5';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { NewPasswordModalImage } from 'src/images';
import { resetPasswordValidationSchema } from 'src/validations/teacher';
import './styles/login.css';
import { TextField } from 'src/components';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function CreateNewPassword() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState('');

  const Continue = () => {
    setOpen(true);
  };

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: resetPasswordValidationSchema,
    onSubmit: async (values) => {
      try {
         
        Continue();
        formik.resetForm();
        // Login(values, formik.resetForm);
      } catch (error) {
        console.error('Error creating student:', error);
      }
    },
  });

  useEffect(() => {
    const images = [
      ResetPasswordBg1,
      ResetPasswordBg2,
      ResetPasswordBg3,
      ResetPasswordBg4,
    ];
    const randomImage = images[Math.floor(Math.random() * images.length)];
    setBackgroundImage(randomImage);
  }, []);

  return (
    <div className="_login_container">
      <Page title="Login">
        <Grid container justifyContent="center">
          <Grid sm={12} xs={12} md={6} lg={6} xl={6}>
            <div className="loginFirstSec">
              <img src={GoldMindsLogo} width={120} height={120} />
              <h1>Create new password</h1>
              <p className="loginDes">
                Please enter a new password. Your new password must be different from previous password.
              </p>
              <form onSubmit={formik.handleSubmit}>
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                  <TextField
                    placeholder="Enter Password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    error={Boolean(formik.touched.password && formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                    right={
                      showPassword ? (
                        <FiEye color="#718096" size={20} onClick={() => setShowPassword(!showPassword)} />
                      ) : (
                        <FiEyeOff onClick={() => setShowPassword(!showPassword)} color="#718096" size={20} />
                      )
                    }
                  />
                  <TextField
                    placeholder="Enter Confirm Password"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    name="confirmPassword"
                    type={showConfirmPassword ? 'text' : 'password'}
                    error={Boolean(formik.touched.confirmPassword && formik.errors.confirmPassword)}
                    helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                    style={{ marginTop: 20 }}
                    right={
                      showConfirmPassword ? (
                        <FiEye color="#718096" onClick={() => setShowConfirmPassword(!showConfirmPassword)} size={20} />
                      ) : (
                        <FiEyeOff
                          color="#718096"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          size={20}
                        />
                      )
                    }
                  />
                  {/* <div className="_login_row">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter Password"
                    value={password}
                    className="_auth_fields"
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                  <div
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {showPassword ? <FiEye color="#718096" size={20} /> : <FiEyeOff color="#718096" size={20} />}
                  </div>
                </div>
                <div className="_login_row" style={{ marginTop: 15 }}>
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    placeholder="Enter Confirm Password"
                    value={confirmPassword}
                    className="_auth_fields"
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                    }}
                  />
                  <div
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {showConfirmPassword ? <FiEye color="#718096" size={20} /> : <FiEyeOff color="#718096" size={20} />}
                  </div>
                </div> */}
                  <div className="forgotPwdSec">
                    <span className="forgotPasswordTxt" onClick={() => navigate('/login')}>
                      Return to login
                    </span>
                  </div>
                </div>
                {/* <button className="_btn" onClick={() => Continue()}>
                  Continue
                </button> */}
                <Button type="submit" fullWidth variant="contained" style={{ height: 55, marginTop: 20 }}>
                  {loading ? <CircularProgress color="inherit" size={20} /> : 'Continue'}
                </Button>
              </form>
            </div>
          </Grid>
          <Grid sm={12} xs={12} md={6} lg={6} xl={6}>
            <div className="loginSecondSec">
              <img src={backgroundImage} alt={'login Background'} className="loginBgImage" />
            </div>
          </Grid>
        </Grid>
        {/* CHANGE STATUS MODAL */}
        <BootstrapDialog aria-labelledby="customized-dialog-title" open={open} maxWidth="xs" fullWidth={true}>
          <div className="_user_modal_header" style={{ paddingBottom: 0 }}>
            <div></div>
            <span onClick={() => setOpen(false)}>
              <IoClose size={25} color="#A0AEC0" />
            </span>
          </div>
          <DialogContent>
            <div className="_user_modal_body">
              <img src={NewPasswordModalImage} />
              <Typography variant="h4" style={{ textAlign: 'center', marginTop: 20 }}>
                You Password has been Successfully Changed.
              </Typography>
              <Button
                variant="contained"
                style={{ height: 50, marginTop: 20, width: 150 }}
                onClick={() => {
                  setOpen(false);
                  navigate('/login');
                }}
              >
                Back to Login
              </Button>
              {/* <button
                className="_btn"
                onClick={() => {
                  setOpen(false);
                  navigate('/login');
                }}
              >
                Back to Login
              </button> */}
            </div>
          </DialogContent>
          <DialogActions></DialogActions>
        </BootstrapDialog>
      </Page>
    </div>
  );
}
